<template>
  <div v-rect-loading="loading" class="referral-dashboard-page">
    <div class="head">
      <div class="label">{{ $t(`${i18nPrefix}.label.myDashboard`) }}</div>
    </div>
    <div class="content">
      <InfoCard class="views" :count="viewsInfo.count" :labelI18nKey="viewsInfo.labelI18nKey"/>
      <div class="referral">
        <div class="title">{{ $t(`${i18nPrefix}.label.referrals`) }}</div>
        <div class="referral-content">
          <InfoCard class="leads clickable" visibleArrow :count="leadsInfo.count" :labelI18nKey="leadsInfo.labelI18nKey" @click.native="handleLeads"/>
          <InfoCard class="resume-submitted clickable" visibleArrow :count="resumeSubmittedInfo.count" :labelI18nKey="resumeSubmittedInfo.labelI18nKey" @click.native="handleResumeSubmitted"/>
          <InfoCard
            v-for="(statusGroup, index) in statusGroupList"
            class="status-group"
            :key="index"
            :class="[index === 0 && 'clickable', statusGroup.name]"
            :visibleArrow="index === 0"
            :count="statusGroup.count || 0"
            :labelI18nKey="`admin.application.candidate.STATUS_GROUP.${statusGroup.name}`"
            @click.native="onStatusGroupClick(statusGroup, index)"
          ></InfoCard>
        </div>
        <div class="referral-help">
          <div class="help-common positions" @click="toCompanyJobList">
            <i class="icon iconfont icona-RecommendPositions"></i>
            <div class="positions-content">
              <span class="label">{{ $t(`${i18nPrefix}.label.referJobs`) }}</span>
              <span class="tip">{{ $t(`${i18nPrefix}.label.referJobsText`) }}</span>
            </div>
            <i class="right-icon el-icon-arrow-right"></i>
          </div>
          <div v-if="!hiddenProgram" class="help-common rules" @click="toReferralRulePage">
            <i class="icon iconfont icona-RecommendRulesPolicies"></i>
            <span class="label">{{ $t(`${i18nPrefix}.label.referRules`) }}</span>
            <i class="right-icon el-icon-arrow-right"></i>
          </div>
          <div class="help-common faq" @click="handleFAQ">
            <i class="icon iconfont icona-RecommendFAQ"></i>
            <span class="label">{{ $t(`${i18nPrefix}.label.referFAQ`) }}</span>
            <i class="right-icon el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InfoCard from './infoCard.vue'
import { ROOT_COMPANY_ID } from '@/constant/company'

export default {
  components: {
    InfoCard
  },
  props: {
    personalInfo: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'personal.referrals.dashboard',
      account: null,
      loading: false,
      viewsInfo: {
        count: 0,
        labelI18nKey: 'personal.referrals.dashboard.label.views'
      },
      leadsInfo: {
        count: 0,
        labelI18nKey: 'personal.referrals.dashboard.label.leads'
      },
      resumeSubmittedInfo: {
        count: 0,
        labelI18nKey: 'personal.referrals.dashboard.label.resumeSubmit'
      },
      statusGroupList: []
    }
  },
  computed: {
    companyId () {
      return this.$route.query.company_id
    },
    hiddenProgram () {
      return this.personalInfo?.employee?.company?.root_company?.id === ROOT_COMPANY_ID.MERCEDES_BENZ
    }
  },
  created () {
    this.account = this.getCurrentAccount()
    this.initData()
  },
  methods: {
    ...mapGetters('account', ['getCurrentAccount']),
    ...mapActions('personal', ['getMyDashboardData']),
    async initData () {
      this.loading = true
      const params = {
        company_id: this.companyId
      }
      try {
        const resp = await this.getMyDashboardData(params)
        if (resp) {
          this.viewsInfo.count = resp.pageViews
          this.leadsInfo.count = resp.leadsCount
          this.resumeSubmittedInfo.count = resp.submitReferralCount
          this.statusGroupList = resp.statusGroupList
        }
      } finally {
        this.loading = false
      }
    },
    handleLeads () {
      this.$router.push({ path: '/recruiting/personal/referral/leads', query: { company_id: this.companyId } })
    },
    handleResumeSubmitted () {
      this.$router.push({ path: '/recruiting/personal/referral/leads/applied', query: { company_id: this.companyId } })
    },
    onStatusGroupClick (statusGroup, index) {
      if (index === 0) {
        this.$router.push({ path: '/recruiting/personal/referral/leads/applied', query: { company_id: this.companyId } })
      }
    },
    toCompanyJobList () {
      if (this.account?.employee) {
        this.$router.push(`/recruiting/company-detail/${this.account.employee.company.id}`)
      } else if (this.companyId) {
        this.$router.push(`/recruiting/company/${this.companyId}/job-list`)
      } else {
        window.location.href = this.$DjangoBaseUrl('/jobseekers/')
      }
    },
    toReferralRulePage () {
      this.$router.push({ path: '/recruiting/personal/referral/program', query: { company_id: this.companyId } })
    },
    handleFAQ () {

    }
  }
}
</script>

<style lang="scss" scoped>
.referral-dashboard-page {
  min-height: calc(100vh - var(--header-height, 124px) - 28px);
  min-height: calc(100dvh - var(--header-height, 124px) - 28px);
  background-color: #fff;

  .head {
    display: flex;
    position: sticky;
    top: -14px;
    height: 52px;
    padding: 16px 0 16px 40px;
    z-index: 3;
    background-color: #fff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);

    .label {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      color: #606266;
    }

    .icon-group {
      flex: 1;
      text-align: right;
      margin-right: 24px;

      .edit-icon {
        margin-right: 28px;
        font-size: 20px;
        color: #0096cc;
        cursor: pointer;
      }

      .download-icon {
        font-size: 20px;
        color: #0096cc;
        cursor: pointer;
      }
    }
  }

  .content {
    background-color: #fff;
    padding: 40px;
    min-height: calc(100vh - 80px - var(--header-height));
    min-height: calc(100dvh - 80px - var(--header-height));

    .views {
      margin-bottom: 40px;
    }

    .referral {
      .title {
        font-size: 16px;
        line-height: 22px;
        color: #606266;
        margin-bottom: 18px;
      }

      .referral-content {
        display: grid;
        grid-template-columns: repeat(auto-fill, 310px); // 设置每个网格宽度为310px
        row-gap: 14px;
        column-gap: 18px;
        align-items: center;
        justify-content: space-between;

        .clickable {
          cursor: pointer;

          &:hover {
            ::v-deep {
              .label {
                .label-text {
                  color: #0096cc;
                }

                .label-icon {
                  color: #0096cc;
                }
              }
            }
          }
        }
      }

      .referral-help {
        display: grid;
        grid-template-columns: repeat(auto-fill, 310px); // 设置每个网格宽度为310px
        row-gap: 14px;
        column-gap: 18px;
        align-items: center;
        justify-content: space-between;
        margin-top: 40px;

        .help-common {
          display: flex;
          align-items: center;
          width: 310px;
          height: 110px;
          background: #f7f7f7;
          box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.08);
          border-radius: 4px;
          cursor: pointer;

          .icon {
            color: #0096cc;
            font-size: 40px;
            margin-left: 24px;
          }

          .label {
            margin-left: 14px;
            flex: 1;
            font-size: 16px;
            color: #303133;
            line-height: 22px;
          }

          .right-icon {
            font-size: 16px;
            margin-right: 28px;
          }
        }

        .faq {
          cursor: initial;
        }

        .positions {
          .positions-content {
            flex: 1;
            display: flex;
            flex-direction: column;
            margin-left: 14px;

            .label {
              margin-left: 0;
              margin-bottom: 10px;
            }

            .tip {
              font-size: 12px;
              line-height: 18px;
              color: #606266;
            }
          }
        }
      }
    }
  }
}
</style>
